/*
 * @Description: Description
 * @Autor: Chen
 * @Date: 2021-03-03 09:05:32
 * @LastEditors: chen
 * @LastEditTime: 2021-03-03 09:33:03
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scoreResult'
})
export class ScoreResultPipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): unknown {
    if (value >= 80) {
      return '通过';
    }
    if (value < 80) {
      return '未通过';
    }
    if (value === '-') {
      return '-';
    }
  }

}
